import Choices from 'choices.js';
import { Controller } from '@hotwired/stimulus';
import 'choices.js/public/assets/styles/choices.min.css';

export default class extends Controller {
  static targets = ['select'];

  initialize() {
    window.choicesInstances ||= {};
  }

  selectTargetConnected(select) {
    const instanceId = this.getOrCreateInstanceId(select);
    const avatarSet = this.getAvatarSet(select);
    const defaultValues = this.getDefaultValues(select);

    const choicesInstance = new Choices(select, {
      allowHTML: true,
      shouldSort: false,
      itemSelectText: '',
      removeItemButton: !select.dataset.notRemoveButton,
      placeholderValue: select.getAttribute('placeholder') || 'Select an option',
      placeholder: true,
      callbackOnCreateTemplates: (template) => ({
        choice: this.choiceTemplate(template, avatarSet),
      }),
    });

    choicesInstance.removeActiveItems();
    choicesInstance.setChoiceByValue(defaultValues);

    window.choicesInstances[instanceId] = choicesInstance;

    select.addEventListener('addItem', () => choicesInstance.hideDropdown());
  }

  selectTargetDisconnected(select) {
    const instanceId = this.getInstanceId(select);
    window.choicesInstances[instanceId]?.destroy();
    delete window.choicesInstances[instanceId];
  }

  getOrCreateInstanceId(element) {
    return this.getInstanceId(element) || this.generateInstanceId(element);
  }

  generateInstanceId(element) {
    const id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    element.dataset.choicesId = id;
    return id;
  }

  getInstanceId(element) {
    return element.dataset.choicesId;
  }

  getAvatarSet(select) {
    try {
      return JSON.parse(select.dataset.avatarSet || '[]');
    } catch {
      return [];
    }
  }

  getDefaultValues(select) {
    try {
      return JSON.parse(select.dataset.defaultValues || '[]');
    } catch {
      return [];
    }
  }

  choiceTemplate(template, avatarSet = []) {
    return ({ classNames }, data) => {
      if (!data.label?.trim()) {
        return template('<div style="display: none;"></div>');
      }

      const baseClass = `${classNames.item} ${classNames.itemChoice} ${classNames.itemSelectable}`;
      const attrs = `
        class="${baseClass}"
        role="option"
        data-id="${data.id}"
        data-value="${data.value}"
        data-choice
        data-select-text
        data-choice-selectable
      `;

      if (avatarSet.length > 0) {
        const avatarUrl = avatarSet.find(([value]) => value === data.value)?.[1];
        if (!avatarUrl) return null;

        return template(`
          <div ${attrs} style="padding: 4px 12px; display: flex; gap: 8px; align-items: center;">
            <img src="${avatarUrl}" alt="${data.label}" style="width: 24px; height: 24px; border-radius: 50%;">
            ${data.label}
          </div>
        `);
      }

      return template(`<div ${attrs}>${data.label}</div>`);
    };
  }
}
